import React, { useEffect, useRef, useState } from "react";
import LinkedInIcon from "@/assets/linkedin.svg";
import InstagramIcon from "@/assets/instagram.svg";
import YouTubeIcon from "@/assets/Youtube.svg";
import FacebookIcon from "@/assets/facebook.svg";
import TwitterIcon from "@/assets/x.svg";
import Investors from "../assets/Investors.svg";
import karatclub from "../assets/KaratClub.svg";
import ScrollTop from "../assets/ScrollTop.svg";
import Sand from "@/assets/Sand.svg";
import MobileSand from "@/assets/MobileSand.svg";
import Suryoday from "@/assets/Suryoday.svg";
import Utkarsh from "@/assets/Utkarsh.svg";
import Bajaj from "@/assets/Bajaj.svg";
import Shriram from "@/assets/Shriram.svg";
import Shivalik from "@/assets/Shivalik.svg";
import SouthIndian from "@/assets/South.svg";

export const Footer = () => {
  const partners = [
    { name: "Suryoday Small<br />Finance Bank", icon: Suryoday },
    { name: "Shivalik Small<br />Finance Bank", icon: Shivalik },
    { name: "Shriram<br />Finance", icon: Shriram },
    { name: "Bajaj<br />Finance", icon: Bajaj },
    { name: "Utkarsh Small<br />Finance Bank", icon: Utkarsh },
    { name: "South Indian<br />Bank", icon: SouthIndian },
  ];

  const duplicatedPartners = [...partners, ...partners];

  // Mobile Karat Wealth is Powered by Component with auto-scroll and manual scroll
  const MobilePartnerBanksSection = () => {
    const scrollContainerRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [showScrollIndicator, setShowScrollIndicator] = useState(true);

    useEffect(() => {
      const container = scrollContainerRef.current;
      if (!container || isPaused) return;

      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      let scrollLeft = container.scrollLeft;
      let direction = 1;

      const scrollInterval = setInterval(() => {
        if (!isPaused && scrollContainerRef.current) {
          scrollLeft += direction * 1;

          if (scrollLeft >= scrollWidth - clientWidth) {
            direction = -1;
          } else if (scrollLeft <= 0) {
            direction = 1;
          }

          if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollLeft = scrollLeft;
          }
        }
      }, 30);

      return () => clearInterval(scrollInterval);
    }, [isPaused]);

    // Hide scroll indicator after 3 seconds
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowScrollIndicator(false);
      }, 3000);

      return () => clearTimeout(timer);
    }, []);

    return (
      <section className="w-full bg-[#1D1D21] p-4 rounded-2xl space-y-4">
        <h2 className="text-[#FFFFFF] text-sm md:text-base md:font-bold font-medium">
          Karat Wealth is Powered by
        </h2>
        {/* Scroll Container */}
        <div
          ref={scrollContainerRef}
          className="w-full overflow-x-auto scroll-smooth"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={() => setIsPaused(true)}
          onTouchEnd={() => setTimeout(() => setIsPaused(false), 1000)}
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          <div className="flex items-center space-x-6 px-2 min-w-max">
            {duplicatedPartners.map((item, index) => (
              <div key={index} className="flex-shrink-0 flex flex-col items-center">
                <div className="rounded-xl flex items-center justify-center p-4 w-32 h-20">
                  <img
                    src={item.icon}
                    alt={item.name.replace(/<br \/>/g, ' ')}
                    className="object-contain max-w-full max-h-full"
                  />
                </div>
                <p
                  className="text-white text-xs text-center mt-3 leading-tight max-w-[120px]"
                  dangerouslySetInnerHTML={{ __html: item.name }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Hide scrollbar for webkit browsers */}
        <style>
          {`
            .scroll-container::-webkit-scrollbar {
              display: none;
            }
            @keyframes scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>
      </section>
    );
  };

  // Desktop Karat Wealth is Powered by without scroll - single row
  const DesktopPartnerBanksSection = (
    <section className="w-full bg-[#1D1D21] p-4 rounded-2xl">
      <h2 className="text-white text-lg font-semibold">
        Karat Wealth is Powered by
      </h2>
      <div className="flex justify-between items-center gap-8">
        {partners.map((item, index) => (
          <div key={index} className="flex flex-col items-center flex-1">
            <div className="rounded-xl bg-black/40 flex items-center justify-center p-4 w-full h-24">
              <img
                src={item.icon}
                alt={item.name}
                className="object-contain max-w-full max-h-16"
              />
            </div>
            <p
              className="text-white text-sm text-center mt-3 leading-tight"
              dangerouslySetInnerHTML={{ __html: item.name }}
            />
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <footer className="bg-[#0B0B0C] text-white">
      <div className="py-10 max-w-7xl mx-auto">
        {/* MOBILE VIEW */}
        <div className="block lg:hidden space-y-6">
          <div className="bg-[#131316] rounded-xl" style={{ marginBottom: '10px' }}>
            <img src={MobileSand} className="mb-4 w-full" alt="Investors" />
          </div>
          <div className="bg-[#131316] p-4 rounded-xl flex items-start gap-4" style={{ marginBottom: '10px', backgroundColor: '#1D1D21' }}>
            <img src={Investors} className="h-auto flex-shrink-0" alt="Investors" />
            <div>
              <p className="font-regular text-xs text-[#FFFFFF99] leading-relaxed">
                Our investors value clarity and access. Every journey is unique, so we offer curated investment opportunities and a seamless experience shaped around your goals, comfort, and pace. So, go ahead, invest your way — with confidence.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center bg-[#1D1D21] p-4 justify-center rounded-2xl gap-4" style={{ marginBottom: '10px' }}>
            <div className="flex justify-center gap-2">
              <a href="https://www.linkedin.com/company/karatclub/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                <img src={LinkedInIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
              </a>
              <a href="https://www.instagram.com/karatclubapp/" target="_blank" rel="noopener noreferrer">
                <img src={InstagramIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
              </a>
              <a href="https://www.youtube.com/@KaratClub" target="_blank" rel="noopener noreferrer">
                <img src={YouTubeIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
              </a>
              <a href="https://www.facebook.com/KaratClubApp" target="_blank" rel="noopener noreferrer">
                <img src={FacebookIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
              </a>
              <a href="https://x.com/KaratClubApp" target="_blank" rel="noopener noreferrer">
                <img src={TwitterIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
              </a>
            </div>
            {/* Added Privacy and Terms for Mobile */}
            <div className="flex gap-4 text-xs text-[#FFFFFF99]">
              <a href="/terms-and-conditions" className="hover:text-white transition-colors">Terms & Conditions</a>

              <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
            </div>
          </div>
        </div>

        {/* DESKTOP VIEW */}
        <div className="hidden lg:block">
          <div className="flex gap-6" style={{ marginBottom: '10px' }}>
            <div className="relative bg-[#131316] p-6 rounded-xl bg-[#1D1D21] flex flex-col min-h-[300px]" style={{ width: '33.33%', flex: '0 0 33.33%' }}>
              <div className="flex-none">
                <img src={Investors} className="mb-4" alt="Investors" />
              </div>
              <div className="absolute flex flex-row items-start flex-grow bottom-0 pt-4 pr-4 pb-4">
                <p className="font-regular text-sm text-[#FFFFFF99] ml-10 h-full flex items-end">
                  Our investors value clarity and access. Every journey is unique, so we offer curated investment opportunities and a seamless experience shaped around your goals, comfort, and pace. So, go ahead, invest your way — with confidence.
                </p>
              </div>
            </div>
            <div className="bg-[#131316] rounded-xl" style={{ width: '65.00%', flex: '0 0 65.00%' }}>
              <div className="flex flex-col justify-between h-full">
                <img
                  src={Sand}
                  className="mb-0 w-full h-full object-cover rounded-xl"
                  alt="KaratClub"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="hidden lg:block max-w-7xl space-y-6" style={{ marginBottom: '10px' }}>
          {/* Second Row: Social + Links + Scroll */}
          <div className="flex gap-6 items-stretch">
            <div className="flex-1 flex justify-between items-center bg-[#1D1D21] p-4 rounded-lg shadow-md">
              <div className="flex items-center gap-10">
                <div className="flex gap-6">
                  <a href="https://www.linkedin.com/company/karatclub/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                    <img src={LinkedInIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
                  </a>
                  <a href="https://www.instagram.com/karatclubapp/" target="_blank" rel="noopener noreferrer">
                    <img src={InstagramIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
                  </a>
                  <a href="https://www.youtube.com/@KaratClub" target="_blank" rel="noopener noreferrer">
                    <img src={YouTubeIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
                  </a>
                  <a href="https://www.facebook.com/KaratClubApp" target="_blank" rel="noopener noreferrer">
                    <img src={FacebookIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
                  </a>
                  <a href="https://x.com/KaratClubApp" target="_blank" rel="noopener noreferrer">
                    <img src={TwitterIcon} fontSize="small" className="text-[#FFFFFF99] hover:text-white transition-colors" />
                  </a>
                </div>
                {/* Added Privacy and Terms for Desktop */}
                <div className="flex gap-6 text-sm text-[#FFFFFF99]">
                  <a href="/terms-and-conditions" className="hover:text-white transition-colors">Terms & Conditions</a>
                  <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
                </div>
              </div>
            </div>
            <div className="pl-6 flex items-center justify-end p-6 rounded-lg bg-[#1D1D21]">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className=""
              >
                <img src={ScrollTop} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;